var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourseMenuStressmeterLocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5713 2H14.857C15.4882 2 15.9999 2.63119 15.9999 3.14286V14.5714C15.9999 15.2026 15.4882 15.7143 14.857 15.7143H12.5713C11.9401 15.7143 11.4285 15.0831 11.4285 14.5714V3.14286C11.4285 2.51166 11.9401 2 12.5713 2Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85721 5.42856H9.14293C9.77412 5.42856 10.2858 6.05975 10.2858 6.57142V14.5714C10.2858 15.2026 9.77412 15.7143 9.14293 15.7143H6.85721C6.22602 15.7143 5.71436 15.0831 5.71436 14.5714V6.57142C5.71436 5.94022 6.22602 5.42856 6.85721 5.42856Z",
    fill: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.14286 8.85715H3.42857C4.05976 8.85715 4.57143 9.48834 4.57143 10V14.5714C4.57143 15.2026 4.05976 15.7143 3.42857 15.7143H1.14286C0.511665 15.7143 0 15.0831 0 14.5714V10C0 9.36881 0.511665 8.85715 1.14286 8.85715Z",
    fill: "#CCCCCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseMenuStressmeterLocked);
export default __webpack_public_path__ + "static/media/course_menu_stressmeter_locked.0e61f3d9fe620caa6638ebdacd159983.svg";
export { ForwardRef as ReactComponent };